import React, { useContext } from "react";
import Products from "./products";
import { resultsFlattener } from "./productQueries";
import { Context } from "../../context";
const Woocommerceproductcategory = (props) => {
    const context = useContext(Context);
    const total = (props.attributes.rows || 1) * (props.attributes.columns || 3);
    const products = resultsFlattener(context.wc.allProducts)
        .results.filter((product) => {
        if (!product.productCategories) {
            return false;
        }
        return product.productCategories.nodes.some((e) => props.attributes.categories.includes(e.databaseId));
    })
        .slice(0, total);
    return React.createElement(Products, { ...props, products: products });
};
export default Woocommerceproductcategory;
